import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ContactModalProvider, useContactModal } from "../../context/ContactModalContext";
import { getSectionsForPath } from "../../data/salesPageSections";
import SalesNavbar from "../../components/sales/SalesNavbar.jsx";
import StickyContactSidebar from "../../components/medical/StickyContactSidebar.jsx";
import SalesHero from "../../components/sales/SalesHero.jsx";
import HCServices from "../../components/HCServices.jsx";
import SalesHeadhuntingSection from "../../components/sales/SalesHeadhuntingSection.jsx";
import LeadershipTeam from "../../components/LeadershipTeam.jsx";
import InsightsSection from "../../components/InsightsSection.jsx";
import StatsAndLogosMarquee from "../../components/StatsAndLogosMarquee.jsx";
import Contact from "../../components/Contact.jsx";
import ContactModal from "../../components/ContactModal.jsx";
import { SALES_SERVICES } from "../../data/salesServicesData";
import Footer from "../../components/Footer.jsx";
import ScrollToTop from "../../components/ScrollToTop.jsx";

function SalesHomeContactButton() {
  const { openContactModal } = useContactModal() || {};
  return (
    <button
      type="button"
      onClick={() => openContactModal?.()}
      className="group btn btn-bg text-gray-900 shrink-0"
    >
      Jetzt Kontakt aufnehmen
      <ArrowRight className="h-5 w-6 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-0.5" aria-hidden />
    </button>
  );
}

export default function SalesLayout() {
  const location = useLocation();
  const isSalesHome = location.pathname === "/sales" || location.pathname === "/sales/";
  const sections = getSectionsForPath(location.pathname);

  return (
    <ContactModalProvider>
      <div data-site="sales" className="min-h-screen bg-bg text-text">
        <SalesNavbar />
        <StickyContactSidebar sections={sections} />
        <ContactModal />
        <main className="min-h-screen">
        {isSalesHome && (
          <>
            <div id="section-hero"><SalesHero /></div>
            <div id="section-services">
              <HCServices
                services={SALES_SERVICES}
                title="Unsere Dienstleistungen für den Vertrieb"
                gridColsClass="sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3"
                pinnedId={null}
              />
            </div>
            <div id="section-headhunting"><SalesHeadhuntingSection /></div>
            <section className="w-full bg-white py-2 md:py-2">
              <div className="container-app mx-auto flex flex-col items-start gap-6 px-4">
                <SalesHomeContactButton />
              </div>
            </section>
            <div id="section-team">
              <LeadershipTeam
                variant="home"
                teamPagePath="/sales/team"
                sectionTitle="Lernen Sie unser Vertriebsteam kennen"
              />
            </div>
            <div id="section-insights">
              <InsightsSection
                basePath="/sales"
                sectionTitle="Einblicke zu Vertrieb, Recruiting und Führungskräften"
              />
            </div>
            <div id="section-stats-logos"><StatsAndLogosMarquee site="sales" /></div>
          </>
        )}
        <Outlet />
        {isSalesHome && <Contact />}
        <Footer />
      </main>
      <ScrollToTop />
    </div>
    </ContactModalProvider>
  );
}